module.exports = __webpack_public_path__ + "img/7_Hills-01.9e53f431.png";